import React, { useEffect, useMemo, useState } from 'react';
import KapalService from '../../services/kapal/KapalService';

const JenisKomoditiEN = ({id}) => {
    let kapalService = useMemo(() => new KapalService(), [])
    // const [urKomoditi, setUrKomoditi] = useState('')
    const [urKomoditiEn, setUrKomoditiEn] = useState('')

    useEffect(() => {
        if(!id) return
        const getJenisDokumen = async () => {
            const response = await kapalService.getJenisKomoditiById(id)
            // setUrKomoditi(response.data.urJenisKomoditi)
            setUrKomoditiEn(response.data.urJenisKomoditiEn)
        }
        getJenisDokumen()
    }, [kapalService, id])

    return (
        <>
            {urKomoditiEn}
        </>
    )
}

export default JenisKomoditiEN